export enum AccountVerificationType {
  None = 'None',
  Email = 'Email',
  Phone = 'Phone',
  CreditCard = 'CreditCard',
  PhotoId = 'PhotoId'
}
